import styled from 'styled-components';

import { CardItem } from 'src/app/components/Elements/Card';

export const OrderHistoryContainer = styled.div`
  ${props => props.theme.mediaQueries.smallDown} {
    padding-left: ${props => props.theme.space['2.0']} !important;
    padding-right: ${props => props.theme.space['2.0']} !important;
  }
`;

export const SectionHeader = styled.h2`
  font-family: ${props => props.theme.fonts.circular} !important;
  font-size: ${props => props.theme.fontSizes.body} !important;
  font-weight: ${props => props.theme.fontWeights.book} !important;
  letter-spacing: ${props => props.theme.letterSpacings.one} !important;
  color: ${props => props.theme.colors.capsuleBlue50} !important;
  margin-top: ${props => props.theme.space['3.0']} !important;
`;

export const NoOrdersCard = styled(CardItem)`
  position: relative;
  min-height: ${props => props.theme.space['38.4']} !important;
`;

export const NoOrdersContent = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ReceiptIcon = styled.img`
  display: block;
  width: auto;
  height: ${props => props.theme.space['6.2']} !important;
  margin-bottom: ${props => props.theme.space['4.0']} !important;
`;
